import { render, staticRenderFns } from "./replaceProductModel.vue?vue&type=template&id=3b5c9b02&scoped=true&"
import script from "./replaceProductModel.vue?vue&type=script&lang=js&"
export * from "./replaceProductModel.vue?vue&type=script&lang=js&"
import style0 from "./replaceProductModel.vue?vue&type=style&index=0&id=3b5c9b02&lang=scss&scoped=scoped&"
import style1 from "./replaceProductModel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c9b02",
  null
  
)

export default component.exports